export default __webpack_public_path__ + "static/media/pic71.c161b99a.jpg";